/**
 * Single-product tabs accordion (woocommerce/single-product/tabs/tabs.php):
 * one item open at a time. Opening an item scrolls it into view once the
 * grid-rows height transition has settled — an item above may be collapsing
 * at the same moment, so scrolling immediately would land on a stale
 * position. Sticky-header clearance comes from scroll-mt-28 on the items.
 */
const PANEL_TRANSITION_MS = 320;

document.addEventListener('click', (e) => {
  const toggle = e.target.closest('.phent-accordion__toggle');
  if (!toggle) return;

  const item = toggle.closest('.phent-accordion__item');
  const accordion = toggle.closest('.phent-product-accordion');
  const wasOpen = item.classList.contains('is-open');

  accordion.querySelectorAll('.phent-accordion__item.is-open').forEach((open) => {
    open.classList.remove('is-open');
    open.querySelector('.phent-accordion__toggle').setAttribute('aria-expanded', 'false');
  });

  if (wasOpen) return;

  item.classList.add('is-open');
  toggle.setAttribute('aria-expanded', 'true');

  setTimeout(() => {
    item.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, PANEL_TRANSITION_MS);
});

// Deep links into a panel (e.g. #tab-reviews) still work: open the item
// that contains the target and let the browser jump to it.
document.addEventListener('DOMContentLoaded', () => {
  const hash = window.location.hash;
  if (!hash) return;

  let target;
  try {
    target = document.querySelector(hash);
  } catch {
    return;
  }

  const item = target && target.closest('.phent-accordion__item');
  if (!item || item.classList.contains('is-open')) return;

  const toggle = item.querySelector('.phent-accordion__toggle');
  if (toggle) toggle.click();
});
